<template>

    <div class="row">
        <div class="col-md-4">
            <div class="d-block mb-3">
                <label class="d-block">
                    <span class="form-label">Assigned To</span>
                    <tech-ac 
                        v-model="form.AssignedTo" 
                        placeholder="Search for a technician..."
                    ></tech-ac>
                </label>
            </div>
        </div>
        <div class="col-md-4">
            <div class="d-block mb-3">
                <label class="d-block">
                    <span class="form-label">Client</span>
                    <client-ac 
                        v-model="form.CustomerNumber" 
                        inputclass="form-control form-control-sm" 
                        placeholder="Search for a client..."
                    ></client-ac>
                </label>
            </div>
        </div>
        <div class="col-md-4">
            <div class="d-block mb-3">
                <label class="d-block">
                    <span class="form-label">Request/Job</span>
                    <job-ac 
                        v-model="form.RequestId" 
                        :client="form.CustomerNumber"
                        :pm-only="pmOnly"
                        placeholder="Search for a request..."
                    ></job-ac>
                </label>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="d-block mb-3">
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link" 
                            :class="{ active: form.Type != 'work' }" 
                            @click="$event.preventDefault(); form.Type = 'assignment'"
                            href="#" 
                        >
                            <span class="badge" :class="form.Type != 'work' ? 'tab-badge-active' : 'tab-badge'">
                                Assignment
                            </span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" 
                            :class="{ active: form.Type == 'work' }" 
                            @click="$event.preventDefault(); form.Type = 'work'"
                            href="#" 
                        >
                            <span class="badge" :class="form.Type == 'work' ? 'tab-badge-active' : 'tab-badge'">
                                Work
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <!--

<label class="d-block mb-3">
                <span>Entry Type</span>
                <kt-select label="Select Type" placeholder="Please select a type" :options="types" label-key="label"
                    value-key="value" v-model="form.Type"></kt-select>
            </label>

-->

    <div class="row" v-if="form.Type != 'work'">
        
        <div class="col-12">
            <div class="row">
                <div class="col-md-6">
                    <label class="d-block mb-3">
                        <span>Estimated Time</span>
                        <input class="form-control" type="text" v-model="form.EstimatedTime" placeholder="Hour Estimate" />
                    </label>
                </div>
                <div class="col-md-6">
                    <label class="d-block mb-3">
                        <span>Complete By</span>
                        <input type="date" 
                            class="form-control" 
                            v-model="form.CompleteByDate" 
                            placeholder="Complete By"
                            ng-disabled="page.delete" 
                            ng-readonly="page.delete"
                        >
                    </label>
                </div>  
            </div>
            
        </div>
        
        <div class="col-12">
            <label class="d-block mb-3">
                <span>Work Assignment</span>
                <textarea class="form-control" placeholder="Work Assignment" v-model="form.WorkAssignment"
                    rows="6"></textarea>
            </label>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6">

        </div>
        <div class="col-md-6">

        </div>
    </div>




    <div class="d-block" v-if="form.Type != 'work'">

        <!--

        <label class="d-block mb-3">
            <span>Estimated Time</span>
            <input class="form-control" type="text" v-model="form.EstimatedTime" placeholder="Hour Estimate" />
        </label>

        <label class="d-block mb-3">
            <span>Complete By</span>
            <input type="date" class="form-control" v-model="form.CompleteByDate" placeholder="Complete By"
                ng-disabled="page.delete" ng-readonly="page.delete">
        </label>

        <div class="row" v-if="form.Type != 'work'">
            <div class="col-6 mx-auto">
                <button class="btn btn-outline-secondary form-control" @click="form.Type = 'work'">
                    Convert to Work Entry
                </button>
            </div>
            <div class="col-6" v-if="form.Id">
                <button class="btn btn-outline-primary form-control" @click="startClock(form.Id)">
                    Start Clock
                </button>
            </div>
        </div>
        -->

    </div>

    <div v-if="form.Type == 'work'">

        <!-- 
    <label class="d-block mb-3">
            <span>Work Complete Date</span>
            <input
                type="date" 
                class="form-control"
                v-model="form.WorkCompleteDate"
                placeholder="Date Completed"
                ng-disabled="page.delete"
                ng-readonly="page.delete"
            />
    </label>
    -->

        <!-- Not a field ...
    <label class="d-block mb-3">
        <span>Hours Worked</span>
        <input type="text" class="form-control" v-model="form.HoursWork" placeholder="Hours Worked"
            ng-blur="page.setInvoiceAmount()" ng-disabled="page.delete" ng-readonly="page.delete" />
    </label>
    -->

        <label class="d-block mb-3">

            <kt-select label="Select Location" placeholder="Please select a location" :options="locations"
                label-key="label" value-key="value" v-model="form.TaskLocation"></kt-select>

            <!-- 
            <span>Location</span>
            <select 
                class="form-control"
                v-model="form.TimeTaskLocation"
                ng-options="row.id as row.name for row in page.timeLocations"
                ng-disabled="page.delete"
                ng-readonly="page.delete"
            ><option value="">Choose Location</option>
            </select>
            -->
        </label>

        <div class="row">
            <div class="col">
                <label class="d-block mb-3">
                    <span>Work Complete Date</span>
                    <input type="date" v-model="form.WorkCompleteDate" class="form-control" placeholder="Work Complete Date"
                        ng-disabled="page.delete" ng-readonly="page.delete" />
                </label>
            </div>
        </div>

        <div class="row">
            <div class="col-6 col-md-4">
                <label class="d-block mb-3">
                    <span>Actual Time</span>
                    <input type="text" v-model="form.ActualTime" class="form-control" placeholder="Time Worked"
                        ng-disabled="page.delete" ng-readonly="page.delete" />
                </label>
            </div>
            <div class="col-6 col-md-4">
                <label class="d-block mb-3">
                    <span>Actual Overtime</span>
                    <input type="text" v-model="form.ActualOvertime" class="form-control" placeholder="Overtime"
                        ng-disabled="page.delete" ng-readonly="page.delete" />
                </label>
            </div>
            <div class="col-12 col-md-4">

                <label class="d-block mb-3">
                    <span>Bill Rate</span>
                    <div class="input-group">
                        <input type="text" v-model="billRate" class="form-control" placeholder="Bill Rate" />
                        <button class="btn btn-outline-secondary" @click="calcShouldBill()">
                            <span><i class="fa fa-refresh"></i></span>
                        </button>
                    </div>
                </label>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <label class="d-block mb-3">
                    <span>Actual Work</span>
                    <textarea type="text" class="form-control" rows="6" v-model="form.ActualWork" placeholder="Time Details"
                    ng-disabled="page.delete" ng-readonly="page.delete"></textarea>
                </label>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <label class="d-block mb-3">
                    <span>Should Bill</span>
                    <input type="text" v-model="form.ShouldBill" class="form-control" placeholder="Billable Amount"
                        ng-disabled="page.delete" ng-readonly="page.delete" />
                </label>
            </div>
            <div class="col-6">
                <label class="d-block mb-3">
                    <span>Invoice Amount</span>
                    <input type="text" v-model="form.InvoiceAmount" class="form-control" placeholder="Invoice Amount"
                        ng-disabled="page.delete" ng-readonly="page.delete" />
                </label>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <label class="d-block mb-3">
                    <span>Invoice Text</span>
                    <textarea type="text" class="form-control" rows="6" v-model="form.InvoiceText" placeholder="Invoice Details"
                        ng-disabled="page.delete" ng-readonly="page.delete"></textarea>
                </label>

            </div>
        </div>

        <!-- duplicate
        <label class="d-block mb-3">
            <span>Task Location</span>
            <select 
                class="form-control"
                v-model="form.TaskLocation"
                ng-options="row.id as row.name for row in page.timeLocations"
                ng-disabled="page.delete"
                ng-readonly="page.delete"
            ><option value="">Choose Location</option>
            </select>
        </label>
        -->


        <div class="row">
            <div class="col">
                <label class="d-block mb-3">
                    <kt-select label="Select Status" placeholder="Please select a status" :options="status" label-key="Status"
                        value-key="Id" v-model="form.Status"></kt-select>
        
                    <!-- 
                    <span>Status</span>
                <select class="form-control" v-model="form.Status" ng-options="row.id as row.name for row in page.timeStatuses"
                    ng-disabled="page.delete" ng-readonly="page.delete">
                    <option value="">Choose Status</option>
                </select>
                -->
                </label>
            </div>
            <div class="col">
                <label class="mb-3 d-block">
                    <span>Paid Amount</span>
                    <input type="text" v-model="form.PaidAmount" class="form-control" placeholder="Paid Amount"
                        ng-disabled="page.delete" ng-readonly="page.delete" />
                </label>
            </div>
        </div>


        

    </div>

    <!-- 
        <label class="mb-3 d-block">
            <span>Request Id</span>
            <input
                type="text"
                v-model="form.RequestId"
                class="form-control"
                placeholder="Request Id"
                ng-disabled="page.delete"
                ng-readonly="page.delete"
            />
        </label>
        -->
</template>


<script setup>

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import Api from "@/services/Api";
import KtSelect from "@/components/UI/KtSelect.vue";
import ClientAc from "@/components/Clients/ClientAc.vue";
import JobAc from "@/components/Jobs/JobAc.vue";
import TechAc from "@/components/Techs/TechAc.vue";

import { useTaskStatusStore } from "@/stores/TaskStatusStore";


const route = useRoute();
const router = useRouter();

// TimeLocations - no store exists yet, using static list
const locations = ref([
    { value: 1, label: "ON-SITE" },
    { value: 2, label: "GTA" },
    { value: 3, label: "WEB" },
    { value: 4, label: "PHONE/EMAIL" },
    { value: 5, label: "IN HOUSE" }
]);

const taskStatusStore = useTaskStatusStore();
const { list: taskStatusList } = storeToRefs(taskStatusStore);

// Convert status store to options array
const status = computed(() => 
    Object.values(taskStatusList.value).map(s => ({
        value: s.Id,
        label: s.Status
    }))
);

taskStatusStore.load();

const props = defineProps({
    pmOnly: {
        type: Boolean,
        default: false
    }
});

const form = defineModel({
    type: Object,
    default: {}
});

const billRate = ref(null);

onMounted(async () => {
    // ... not needed
});

const startClock = (id) => {
    router.push({
        path: "/clock/edit/" + id
    });
    // console.debug(form.value);
};

const calcShouldBill = () => {
    form.value.InvoiceAmount =
        form.value.ShouldBill =
        form.value.ActualTime * billRate.value;
};

</script>

<style scoped>
/* Tab badge styling */
.tab-badge {
    background-color: #e9ecef;
    color: #495057;
    font-weight: 500;
    padding: 0.35em 0.65em;
}

.tab-badge-active {
    background-color: #3B9796;
    color: #fff;
    font-weight: 500;
    padding: 0.35em 0.65em;
}

.nav-link {
    border: none;
    background: transparent;
}

.nav-link:hover .tab-badge {
    background-color: #3B9796;
    color: #fff;
}
</style>